import { StatusVariant } from 'core-system/Card/CardStatus'
import { ChipVariants } from 'core-system/Chip'

export const getRoleChipConfig = (
  isAdmin: boolean,
  isPrimaryAccountHolder: boolean
): { roleChipVariant: ChipVariants; roleChipLabel: string } => {
  if (isPrimaryAccountHolder) {
    return {
      roleChipVariant: 'blue',
      roleChipLabel: 'owner',
    }
  } else if (isAdmin) {
    return {
      roleChipVariant: 'green',
      roleChipLabel: 'admin',
    }
  } else {
    return {
      roleChipVariant: 'regular',
      roleChipLabel: 'regular',
    }
  }
}

export const getRoleCardConfig = (
  isAdmin: boolean,
  isPrimaryAccountHolder: boolean
): { roleCardStatusVariant: StatusVariant; roleCardLabel: string } => {
  if (isPrimaryAccountHolder) {
    return {
      roleCardStatusVariant: 'blue',
      roleCardLabel: 'owner',
    }
  } else if (isAdmin) {
    return {
      roleCardStatusVariant: 'green',
      roleCardLabel: 'admin',
    }
  } else {
    return {
      roleCardStatusVariant: 'regular',
      roleCardLabel: 'regular',
    }
  }
}
